<template>
  <div>
    <aside class="breakout-container slide-out-transition">
      <div class="app-container">
        <div class="banner-content media --sm">
          <div class="banner-icon">
            <div class="icon-container">
              <!-- @CreditReportRemoval -->
              <!-- <svg width="52" height="46" xmlns="http://www.w3.org/2000/svg">
                <g id="Page-1" fill="none" fill-rule="evenodd">
                  <g id="Desktop-HD" transform="translate(-116 -61)">
                    <g
                      id="Group"
                      transform="rotate(-1 3149.6719926 -6159.87587057)"
                    >
                      <path
                        d="M13.2497546 44.78508135c-6.21790987-11.21740637-2.20217386-25.3309265 8.96939745-31.5234296 11.1715713-6.1925031 25.26853107-2.11901417 31.48644095 9.0983922 4.87570093 8.7959973 3.4590115 19.37273607-2.76611632 26.5147881-.78326246.89863236-1.64264903 1.74288886-2.57520377 2.52238091"
                        id="Path"
                        stroke="#E7E7E7"
                        stroke-width="5.41015216"
                        stroke-dasharray="27.05075988769531 1.352538049221039"
                      />
                      <path
                        d="M18.24230217 51.09885297c-9.63995189-8.37988232-10.6335686-23.01990665-2.21930504-32.69940962 8.41426355-9.67950297 23.0500969-10.73305365 32.69004878-2.35317132 9.63995188 8.37988232 10.6335686 23.01990666 2.21930504 32.69940962-8.41426356 9.67950297-23.0500969 10.73305365-32.69004878 2.35317132z"
                        id="RED_2"
                        stroke="#FF6A5D"
                        stroke-width="5.41015216"
                        stroke-dasharray="27.35372591018676 123.9574043273926"
                      />
                      <path
                        d="M18.24230217 51.09885297c-9.63995189-8.37988232-10.6335686-23.01990665-2.21930504-32.69940962 8.41426355-9.67950297 23.0500969-10.73305365 32.69004878-2.35317132 9.63995188 8.37988232 10.6335686 23.01990666 2.21930504 32.69940962-8.41426356 9.67950297-23.0500969 10.73305365-32.69004878 2.35317132z"
                        id="RED_1"
                        stroke="#FD9A85"
                        stroke-width="5.41015216"
                        stroke-dasharray="13.84998874664307 130.8824096679687"
                      />
                      <path
                        d="M11.79754458 25.25034072C16.37500044 13.32566052 29.79228634 7.384783 41.76589148 11.9810194 53.73949662 16.57725577 59.73526024 29.9701048 55.15780438 41.894785c-4.57745586 11.9246802-17.99474176 17.86555771-29.9683469 13.26932133-11.97360514-4.59623638-17.96936875-17.98908542-13.3919129-29.91376562z"
                        id="YELLOW_2"
                        stroke="#FFCE48"
                        stroke-width="5.41015216"
                        stroke-dasharray="27.05075988769531 123.9574043273926"
                      />
                      <path
                        d="M33.8829639 10.35353771c12.7711161.22292066 22.9426969 10.79914544 22.71886164 23.62265926-.22383527 12.82351382-10.75832475 23.03831279-23.52944085 22.81539213-12.7711161-.22292066-22.9426969-10.79914544-22.71886164-23.62265926.22383527-12.82351382 10.75832474-23.03831279 23.52944084-22.81539213z"
                        id="GREEN_2"
                        stroke="#00CC7B"
                        stroke-width="5.41015216"
                        stroke-dasharray="27.35372591018676 123.9574043273926"
                      />
                      <path
                        d="M55.43503803 26.01203657c2.7525664 7.99403325.85307422 16.46925211-4.26272517 22.49716125-.8565998 1.0093253-1.80337466 1.9500358-2.83358439 2.80838347-2.1123882 1.75999465-4.57556357 3.1737095-7.3314207 4.12262722-12.12671749 4.17556368-25.3284963-2.22995133-29.48699836-14.30711825-4.15850206-12.07716691 2.30101279-25.25260825 14.42773027-29.42817194 12.12671747-4.17556369 25.3284963 2.22995133 29.48699835 14.30711825z"
                        id="BLUE_2"
                        stroke="#4B5EFF"
                        stroke-width="5.41015216"
                        stroke-dasharray="18.00498580932617 132.6136478424072"
                      />
                      <text
                        id="785"
                        font-family="Calibre-Semibold, Calibre"
                        font-size="20.6999995"
                        font-weight="500"
                        fill="#FFF"
                      >
                        <tspan x="19.1762593" y="41.2077911">785</tspan>
                      </text>
                    </g>
                  </g>
                </g>
              </svg> -->
              <!-- END @CreditReportRemoval -->
            </div>
            <!-- @CreditReportRemoval -->
            <span
              >Set financial goals and get personalized guidance to help you
              achieve them.</span
            >
            <!-- <span
              >Set financial goals, save articles, and track your credit with a
              Bankrate account</span
            >-->
            <!-- END @CreditReportRemoval -->
          </div>
          <a
            href="/app/create-account"
            class="onboarding-banner-button button --primary"
          >
            Create Account
          </a>
        </div>

        <button
          class="js-onboarding-banner-close banner-close button --close icon --sm"
          role="button"
        >
          <svg
            class="icon__glyph"
            width="25"
            height="25"
            viewBox="0 0 25 25"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            aria-hidden="true"
            aria-describedby="close-modal-text"
          >
            <title>Close</title>
            <defs>
              <path
                id="c"
                d="M11.5 11.5V3h2v8.5H22v2h-8.5V22h-2v-8.5H3v-2h8.5z"
              />
            </defs>
            <use
              transform="rotate(45 12.5 12.5)"
              xlink:href="#c"
              fill-rule="evenodd"
            />
          </svg>
          <span id="close-modal-text" class="+visually-hidden"
            >Close Modal Window</span
          >
        </button>
      </div>
    </aside>
    <auth-modal
      :bedrock-api-host="bedrockApiHost"
      :bedrock-client-token="bedrockClientToken"
      :bedrock-client-secret="bedrockClientSecret"
      use-case="general"
      active-tab="create"
    />
  </div>
</template>

<script>
import { AuthModal } from '@bankrate/cxp-components'

export default {
  data: () => ({
    bedrockApiHost: process.env.BEDROCK_API_HOST,
    bedrockClientToken: process.env.BEDROCK_API_CLIENT_TOKEN,
    bedrockClientSecret: process.env.BEDROCK_API_CLIENT_SECRET
  }),
  created: function() {
    if (!this.hasBannerCookie) {
      var date = new Date()
      const lifetime = 12 * 60 * 60 * 1000
      document.cookie = `banner=1; Path=/; Expires=${date.setTime(
        date.getTime() + lifetime
      )}`
    }
  },
  mounted: function() {
    // var onboardingButton = document.querySelector('.onboarding-banner-button')
    var banner = document.querySelector('.breakout-container')
    var closeIcon = document.querySelector('.js-onboarding-banner-close')

    // banner &&
    //   onboardingButton &&
    //   onboardingButton.addEventListener('click', function() {
    //     window.openBaeModal()
    //     banner.style.display = 'none'
    //   })

    banner &&
      closeIcon &&
      closeIcon.addEventListener('click', function() {
        banner.style.display = 'none'
      })
  },
  components: {
    AuthModal
  }
}
</script>

<style lang="scss" scoped>
.breakout-container {
  width: 100%;
  margin: 0 auto;
  padding-bottom: 20px;
  position: relative;
  background-color: #18243d;
}

.app-container {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  color: white;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.banner-icon {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  color: white;
  margin: 10px 5%;
}

.icon-container {
  width: 50px;
  text-align: center;
  display: flex;
  margin-right: 15px;
}

.banner-icon svg {
  overflow: visible;
  margin-right: 10px;
}

.banner-content {
  padding: 20px 0;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: flex-start;
  width: 100%;
}

.banner-content span {
  font-family: 'Calibre-Semibold', Arial, sans-serif;
  font-size: 18px;
  margin-left: 5px;
  width: 80%;
}

.button.\--close {
  position: absolute;
  right: 5%;
  top: 45px;
  -ms-flex-item-align: start;
  align-self: flex-start;
  svg {
    fill: white;
  }
}

.button svg {
  height: 25px;
  width: 25px;
}

.banner-header {
  color: white;
  text-align: center;
  padding-left: 10px;
}

.banner-close {
  background-color: transparent;
  padding: 0;
}

.media__figure {
  margin-bottom: 15px;
}

.media__body {
  margin-bottom: 10px;
}

.onboarding-banner-button {
  width: 90%;
  margin: 0 auto;
  color: white;
  white-space: nowrap;
  -webkit-transition: background-color 0s;
  -o-transition: background-color 0s;
  transition: background-color 0s;
  &:focus,
  &:hover {
    color: white;
    background-color: #3139f2;
  }
}

.app-container,
.banner-header {
  color: black;
}

@media (min-width: 1020px) {
  .breakout-container {
    padding-bottom: 0;
  }
  .app-container {
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -ms-flex-direction: row;
    flex-direction: row;
  }

  .banner-content {
    width: 90%;

    span {
      font-size: 24px;
      width: 100%;
    }
  }

  .breakout-container .banner-content {
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -ms-flex-direction: row;
    flex-direction: row;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    font-size: 24px;
    justify-content: center;
  }

  .banner-icon {
    margin: 0 10px 0 0;
  }

  .breakout-container .banner-header {
    text-align: left;
    padding-left: 0;
  }

  .breakout-container .onboarding-banner-button {
    padding: 12px 35px;
    width: 315px;
    margin: 0;
  }

  .breakout-container .button.\--close {
    -ms-flex-item-align: center;
    -ms-grid-row-align: center;
    align-self: center;
    top: calc(50% - 12px);
    right: 30px;
  }
}
</style>
